<template>
  <div>
    <ModuleHeader>Valoración de inventario (Insumos) </ModuleHeader>
    <v-overlay v-if="loadingData">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-card>
      <v-card-text>
        Seleccione el almacen y departamento para conocer la valuacion de
        inventario
        <v-row>
          <v-col cols="12" md="4">
            <v-select v-model="selectedAlmacen" label="Almacen" :items="origenes" item-text="Nombre" item-value="id">
            </v-select>
          </v-col>
          <v-col cols="12" md="4">
            <v-select v-model="selectedDepartamento" label="Departamentos" :items="departamentos" item-text="Nombre"
              item-value="id">
            </v-select>
          </v-col>
          <v-col cols="12" md="4">
            <v-switch v-model="hideZero" label="Ocultar insumos en cero existencias">
            </v-switch>
          </v-col>
          <v-col>
            <v-btn :disabled="!selectedAlmacen || !selectedDepartamento" @click="calcularValoracion()"
              color="success">Calcular</v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col md="8" cols="12">
            Resultados: <br />
            <b>Total en Costo Promedio :{{
              $pgsHelper.formatNumber(totales.total)
              }}</b><br />
            <b>Total en Ultimo Costo :{{
              $pgsHelper.formatNumber(totales.totalUltimoCosto)
              }}</b>
          </v-col>

          <v-col md="2" cols="6" class="text-right">
            <v-btn v-if="inusmosRendered.length > 0" color="green" dark
              @click="exportExcel"><v-icon>mdi-file-excel-box</v-icon>
              Exportar a Excel
            </v-btn>
          </v-col>
          <v-col md="2" cols="6" class="text-right">
            <v-btn v-if="inusmosRendered.length > 0" color="red" dark
              @click="generatePdf"><v-icon>mdi-file-pdf-box</v-icon>
              Exportar a PDF
            </v-btn>
          </v-col>
          <v-col md="12">
            <v-text-field v-model="filter" label="Filtrar"></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-text>
        <v-simple-table dense>
          <thead>
            <tr>
              <th>Identificador</th>
              <th>Nombre</th>
              <th>Categoria</th>
              <th>Existencia</th>
              <th>Unidad Medida</th>
              <th>Costo Promedio</th>
              <th>Ultimo Costo</th>
              <th>Total Promedio</th>
              <th>Total Ultimo Costo</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="inusmosRendered.length == 0">
              <td colspan="16">No se encontraron datos</td>
            </tr>
            <template v-for="(prod, index) in inusmosRendered">
              <tr :key="index">
                <td>
                  {{ prod.Id }}
                </td>
                <td>
                  {{ prod.Nombre }}
                </td>
                <td>{{ prod.NombreCategoria }}</td>
                <td>
                  {{ $pgsHelper.formatNumber(prod.Existencia) }}
                </td>
                <td>
                  {{ prod.UnidadMedida }}
                </td>
                <td>
                  {{ $pgsHelper.formatNumber(prod.Costo) }}
                </td>
                <td>
                  {{ $pgsHelper.formatNumber(prod.UltimoCosto) }}
                </td>
                <td>
                  <b>{{ $pgsHelper.formatNumber(prod.Total) }}</b>
                </td>
                <td>
                  <b>{{ $pgsHelper.formatNumber(prod.TotalUltimoCosto) }}</b>
                </td>
              </tr>
            </template>
          </tbody>
        </v-simple-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import moment from "moment";
import GenericExcelExporter from "../../clases/ExcelMaker/GeneralExcel";
import ValoracionInventarios from "../../clases/PdfMakers/ValoracionInventarios";
import pdfmake from "pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfmake.vfs = pdfFonts.pdfMake.vfs;
import { mapActions } from "vuex";

export default {
  name: "ValoracionInventario",
  components: {
    /*Select2,*/
  },
  props: [],
  data() {
    return {
      hideZero: false,
      selectedAlmacen: null,
      selectedDepartamento: null,
      costos: {},
      Categories: [],
      loadingData: false,
      insumos: [],
      filter: "",
    };
  },
  computed: {
    origenes() {
      let ori = [
        {
          id: "All",
          Nombre: "Todos",
        },
      ];
      let origenes = this.$store.getters.getCentrosConsumo;
      origenes.forEach((orig) => {
        ori.push(orig);
      });
      return ori;
    },

    departamentos() {
      let dep = [];
      let departamentos = this.$store.getters.getPDVDepartamentos;
      departamentos.forEach((de) => {
        dep.push(de);
      });
      return dep;
    },
    inusmosRendered() {
      let insumos = this.insumos;
      if (this.hideZero) {
        insumos = insumos.filter((insumo) => insumo.Existencia > 0);
      }
      if (this.filter != "") {
        const filterUpper = this.filter.toUpperCase();
        return insumos.filter(
          (insumo) =>
            insumo.Nombre?.toUpperCase().includes(filterUpper) ||
            insumo.NombreCategoria?.toUpperCase().includes(filterUpper)
        );
      }
      return insumos;
    },
    totales() {
      let total = this.insumos.reduce(
        (partialSum, insumo) => partialSum + insumo.Total,
        0
      );
      let totalUltimoCosto = this.insumos.reduce(
        (partialSum, insumo) => partialSum + insumo.TotalUltimoCosto,
        0
      );
      return {
        total,
        totalUltimoCosto,
      };
    },
  },
  methods: {
    ...mapActions("Categorias", { fetchCategories: "getCategories" }),
    async generatePdf() {
      const almacenSeleccionado = this.$pgsHelper.getById(
        this.origenes,
        "id",
        this.selectedAlmacen
      );
      const departamentoSeleccionado = this.$pgsHelper.getById(
        this.departamentos,
        "id",
        this.selectedDepartamento
      );
      console.log(almacenSeleccionado, departamentoSeleccionado);
      let mainData = {
        Almacen:
          this.selectedAlmacen != "All" ? almacenSeleccionado.Nombre : "All",
        Departamento: departamentoSeleccionado.Nombre,
        FG: new moment().format("DD/MM/YYYY"),
        HG: new moment().format("HH:mm:ss"),
        TITLE: "Valoración inventario",
        data: this.inusmosRendered,
      };
      let docData = ValoracionInventarios.getDocData(mainData);
      pdfmake.createPdf(docData).open();
    },
    exportExcel() {
      const options = {
        json_fields: {
          Id: "Id",
          Nombre: "Nombre",
          Categoria: " NombreCategoria",
          Existencia: "Existencia",
          "Unidad Medida": "UnidadMedida",
          "Costo Promedio": "Costo",
          "Ultimo Costo": "UltimoCosto",
          "Total Promedio": "Total",
          "Total Ultimo Costo": "TotalUltimoCosto",
        },
      };
      GenericExcelExporter.generateExcelBuffer(this.inusmosRendered, options)
        .then((buffer) => {
          const blob = new Blob([buffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = "Valoracion de inventario.xlsx";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => console.error("Error exportando:", error));
    },
    getCategoryById(code) {
      let itemIndex = this.$_.findIndex(this.Categories, { id: code });
      if (itemIndex >= 0) {
        return this.Categories[itemIndex];
      }

      return false;
    },
    async getCategories() {
      this.Categories = await this.fetchCategories();
    },
    async getCostos() {
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      const data = await firestore.queryBuilder("PDV_Costos", [
        firestore.where(
          "Tenant",
          "==",
          this.$store.getters.getFirebaseApp.tenant
        ),
      ]);
      let globalCosto = {};
      let costos = data.docs.map((doc) => {
        return { id: doc.ref.id, ...doc.data() };
      });
      costos.forEach((element) => {
        let prod = Object.entries(element.pds);
        prod.forEach((pd) => {
          if (!globalCosto[pd[0]]) {
            globalCosto[pd[0]] = [];
            globalCosto[pd[0]].push({ depto: element.dpt, ...pd[1] });
          } else {
            globalCosto[pd[0]].push({ depto: element.dpt, ...pd[1] });
          }
        });
      });
      this.costos = globalCosto;
    },
    calcularValoracion() {
      let prod = this.$store.getters.getProductos;
      let origenes = this.$store.getters.getOrigenes;
      let productos = [];
      prod.forEach((element) => {
        element.categoria_name = this.getCategoryById(element.Categoria).Nombre;

        if (
          (element.Tipo == "AYB-Insumo" || element.Tipo == "Producto") &&
          !element.Dlat
        ) {
          productos.push(element);
        }
        //element.Orden = (element.Orden)?element.Orden:0;
      });

      productos.forEach((producto) => {
        let invData = [];
        let matchCount = 0;
        origenes.forEach((origen, index) => {
          let origenesNames = this.$store.getters.getCentrosConsumo;
          let itemIndex = this.$_.findIndex(origenesNames, {
            id: origen.Origen,
          });
          origen.nombreOrigen = origenesNames[itemIndex]?.Nombre;
          let OrProd = Object.entries(origen.Productos);
          let productMatch = "";
          OrProd.forEach((oProducto) => {
            if (oProducto[0] == producto.id) {
              productMatch = oProducto;
              matchCount++;
              //this.$pgsHelper.log(oProducto[1]);
              /* let pro = producto;
                    let idCompuesto = pro.id+'_'+origen.Origen;
                    pro.Existencia = oProducto[1].Stock;
                    pro.compId = idCompuesto;
                    newProductos.push({id:idCompuesto ,Existencia: oProducto[1].Stock,...producto});*/
            }
          });
          if (productMatch != "") {
            invData.push({
              Origen: origen.Origen,
              Price: productMatch[1],
              Costo: this.$pgsHelper.formatNumber(
                this.costos[producto.id]?.cto?.C || 0
              ),
              NombreOrigen: origen.nombreOrigen,
            });
          }
        });
        producto.Costeo = this.costos[producto.id];
        producto.CosteoUltimo = this.costos[producto.id];
        producto.existenciaPrecio = invData;
        producto.existenciaData = invData;
      });

      let data = productos;

      let insumos = this.$_.orderBy(data, "categoria_name", "asc");
      let filteredDataByAlmacen = [];
      if (this.selectedAlmacen) {
        insumos.forEach((item) => {
          let costo = 0;
          let ultimoCosto = 0;
          let existCosto = this.$pgsHelper.getById(
            item.Costeo,
            "depto",
            this.selectedDepartamento
          );
          if (existCosto) {
            costo = existCosto.cto.C;
            ultimoCosto = existCosto.uct.C;
          }
          if (this.selectedAlmacen == "All") {
            let totalExistencia = 0;
            item.existenciaData.forEach((existenciaData) => {
              totalExistencia += Number(existenciaData.Price.Stock);
            });
            filteredDataByAlmacen.push({
              Id: item.id,
              Nombre: item.Nombre,
              NombreCategoria: item.categoria_name,
              Existencia: totalExistencia,
              UnidadMedida: item?.Extra?.AYB?.UM ? item.Extra.AYB.UM : "PZ",
              Costo: costo,
              UltimoCosto: ultimoCosto,
              Total:
                totalExistencia > 0
                  ? Number(costo * Number(totalExistencia))
                  : 0,
              TotalUltimoCosto:
                totalExistencia > 0
                  ? Number(ultimoCosto * Number(totalExistencia))
                  : 0,
            });
          } else {
            let existAlmacen = this.$pgsHelper.getById(
              item.existenciaData,
              "Origen",
              this.selectedAlmacen
            );
            if (existAlmacen) {
              filteredDataByAlmacen.push({
                Id: item.id,
                Nombre: item.Nombre,
                NombreCategoria: item.categoria_name,
                Existencia: Number(existAlmacen.Price.Stock),
                UnidadMedida: item?.Extra?.AYB?.UM ? item.Extra.AYB.UM : "PZ",
                Costo: costo,
                UltimoCosto: ultimoCosto,
                Total:
                  existAlmacen.Price.Stock > 0
                    ? Number(costo * Number(existAlmacen.Price.Stock))
                    : 0,
                TotalUltimoCosto:
                  existAlmacen.Price.Stock > 0
                    ? Number(ultimoCosto * Number(existAlmacen.Price.Stock))
                    : 0,
              });
            }
          }
        });
      }
      this.insumos = filteredDataByAlmacen;
    },
  },
  watch: {},
  mounted() {
    this.getCategories();
    this.getCostos();
  },
  beforeCreate: function () { },
  beforeMount: function () { },
};
</script>

<style></style>
